/**
 * @file HOC passing a basename prop to a wrapped component.
 */

import React from 'react';
import { withRouter } from 'react-router-dom';

import { BASENAME } from '../../constants/basenames';

/**
 * Higher order component providing basename to its children.
 *
 * @param {React.Component} WrappedComponent - The wrapped component.
 * @param {BASENAME} [basename] - Optionally pass a manual basename.
 * @returns {Component}
 */
const withBasename = (WrappedComponent, basename) => {
  // For backwards compatibility reasons where the HOC accepted manually
  // its basename
  if (basename && Object.values(BASENAME).includes(basename)) {
    return props => <WrappedComponent basename={basename} {...props} />;
  }

  return withRouter(({ match, ...props }) => (
    <WrappedComponent
      basename={match.params.basename}
      match={match}
      {...props}
    />
  ));
};

export default withBasename;
